import * as React from "react";
export var If = function (_a) {
    var condition = _a.condition, children = _a.children;
    if (condition)
        return React.createElement(React.Fragment, null, children);
    return null;
};
